define(
	'actions/groups',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes",
	"shared/crm"
	],
	function($,_,Backbone,React,AppDispatcher,Constants, CRM){
		return Backbone.Model.extend({
			init: function(params) {
			},
			dispatchAddGroupEvent: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_GROUP,
					data: params
				});
			},
			dispatchUpdateGroupEvent: function(guid, params) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_GROUP,
					id: guid,
					data: params
				});
			},
			deletedGroup: function(guid) {
				AppDispatcher.dispatch({
					actionType: Constants.DELETED_GROUP,
					id: guid
				});
			},
			truncateGroup: function() {
				AppDispatcher.dispatch({
					actionType: Constants.TRUNCATE_GROUP
				});
			},
			updateGroup: function(group_id, data) {
				var self = this;

				window.api.request("groups", group_id).update({data:JSON.stringify(data)}).done(function(response) {
					self.dispatchUpdateGroupEvent(group_id, {
						name: response.data.name,
						students: response.data.students
					});
				});
			},
			initGroup: function(item) {
				return {
					id: item.data.guid,
					section_guid: item.data.section_guid,
					name: item.data.name,
					created_at: item.data.created_at,
					updated_at: item.data.updated_at,
					students: item.data.students
				};
			},
			pullGroup: function(guid) {
				var self = this;
				window.api.get("groups",guid).done(function(response) {
					self.dispatchUpdateGroupEvent(guid, {
						students: this.response.data.students
					});
				});
			},
			pull: function() {
				var self = this;
				var groups = [];

				window.api.request("groups", null).each(function iterator (index, item) {
					groups.push(self.initGroup(item));
					// self.pullGroup(item.data.guid);
				}, function onComplete () {
					self.dispatchAddGroupEvent(groups);
				});
			},
			pullFromClass: function(sectionGuid) {
				var self = this;
				this.truncateGroup();
				
				var groups = [];
				window.api.request("groups", {section_guid: sectionGuid}).each(function iterator (index, item) {
					groups.push(self.initGroup(item));
				}, function onComplete () {
					self.dispatchAddGroupEvent(groups);
				});
			},
			createGroup: function(sectionGuid, params, callback) {
				var self = this;
				window.api.request("groups").create({'section_guid' : sectionGuid, 'data' : JSON.stringify(params)}).done(function(response) {
					self.dispatchAddGroupEvent({
						id: response.data.guid,
						section_guid: response.data.section_guid,
						name: response.data.name,
						created_at: response.data.created_at,
						updated_at: response.data.updated_at,
						students: []
					});

					CRM.event('group:create', response.data);

					if(typeof callback == "function")
						callback();
				});
			},
			deleteGroup: function(guid) {
				var self = this;

				window.api.request("groups", guid).delete({'data':''}).done(function() {
					self.deletedGroup(guid);
					CRM.event('group:delete', {guid: guid});
				})
			},
			refreshGroups : function(section_guid) {
				AppDispatcher.dispatch({
					actionType: Constants.CLEAR_SECTION_CACHE,
					data:{
						section_guid: section_guid
					}
				});
			}
		});
	}
);
